import { computed } from 'vue'
import type { ComputedRef } from 'vue'

import { usePermissionsStore } from '@/pinia-store/usePermissionsStore'
import { AuthorizationPermissions, AuthorizationResourcesAndSubjects } from '@/types/authorization'

/**
 * Pode EXPORTAR as folhas em lote (`attendance_sheet_exporting` = receptor básico+
 * ou perfil Extrator) em algum recurso do ds_attendance — escala, unidade ou
 * empresa, como `canExportAttachments` e `canEmitSheetRecord` resolvem. É a
 * permissão de `GET containers/export`: sem ela, a aba "Registros de plantão" do
 * modal de exportação levaria a um 403 certo (caso do emissor puro).
 *
 * Isto é UX, não segurança: a barreira real é o 403 do backend.
 */
export function useCanExportSheets(): ComputedRef<boolean> {
  const permissionsStore = usePermissionsStore()
  return computed(() =>
    [
      AuthorizationResourcesAndSubjects.DsAttendance,
      AuthorizationResourcesAndSubjects.DsAttendanceHealthUnit,
      AuthorizationResourcesAndSubjects.DsAttendanceCompany
    ].some((resourceType) =>
      permissionsStore.checkAnyRessources({
        permission: AuthorizationPermissions.AttendanceSheetExporting,
        resourceType
      })
    )
  )
}
